const VIEW_LATENCY_PREFIX = '[view-latency]';

export const nowMs = () => {
  if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
    return performance.now();
  }
  return Date.now();
};

export const elapsedMs = (startedAt) => Math.round((nowMs() - startedAt) * 10) / 10;

export const utf8ByteLength = (value) => {
  if (value == null) return 0;
  const text = typeof value === 'string' ? value : JSON.stringify(value);
  if (typeof TextEncoder !== 'undefined') {
    return new TextEncoder().encode(text).length;
  }
  return text.length;
};

const summarizeValue = (value) => {
  if (Array.isArray(value)) {
    return { type: 'array', length: value.length };
  }
  if (value && typeof value === 'object') {
    return { type: 'object', keys: Object.keys(value).length };
  }
  return { type: typeof value, isPresent: value != null };
};

export const summarizeViewData = (dataByKey = {}) =>
  Object.fromEntries(
    Object.entries(dataByKey || {}).map(([key, value]) => [key, summarizeValue(value)])
  );

export const logViewLatency = (event, details = {}) => {
  const payload = {
    at: new Date().toISOString(),
    ...details,
  };
  console.log(`${VIEW_LATENCY_PREFIX} ${event}`, payload);
};

export const logViewLatencyError = (event, error, details = {}) => {
  const payload = {
    at: new Date().toISOString(),
    message: error?.message || String(error),
    status: error?.status || null,
    ...details,
  };
  console.warn(`${VIEW_LATENCY_PREFIX} ${event}`, payload);
};
